import {
  DEFAULT_QUICK_KEYS,
  TCountryMode,
  X_HASHTAG_STORAGE_PREFIX,
} from './constants';

export interface IXHashtagCountryPrefs {
  countryMode: TCountryMode;
  activeQuickKeys: string[];
  customCountries: string[];
}

export function getCountryPrefsStorageKey(): string {
  try {
    const openId = sessionStorage.getItem('openId')?.replace(/"/g, '') || '';
    return `${X_HASHTAG_STORAGE_PREFIX}_${openId || 'default'}`;
  } catch {
    return `${X_HASHTAG_STORAGE_PREFIX}_default`;
  }
}

function normalizeCountryPrefs(data: unknown): IXHashtagCountryPrefs | null {
  // 兼容旧版：仅存 customCountries 数组
  if (Array.isArray(data)) {
    const customCountries = data.filter(
      (code): code is string => typeof code === 'string',
    );
    if (customCountries.length === 0) {
      return null;
    }
    return {
      countryMode: 'custom',
      activeQuickKeys: [...DEFAULT_QUICK_KEYS],
      customCountries,
    };
  }

  if (!data || typeof data !== 'object') {
    return null;
  }

  const raw = data as Partial<IXHashtagCountryPrefs>;
  const countryMode: TCountryMode =
    raw.countryMode === 'custom' ? 'custom' : 'quick';
  const activeQuickKeys = Array.isArray(raw.activeQuickKeys)
    ? raw.activeQuickKeys.filter((key): key is string => typeof key === 'string')
    : [...DEFAULT_QUICK_KEYS];
  const customCountries = Array.isArray(raw.customCountries)
    ? raw.customCountries.filter(
      (code): code is string => typeof code === 'string',
    )
    : [];

  if (countryMode === 'custom') {
    // customCountries 为空表示「全部国家」（与 RadioAllMultipleSelect 的 All 一致）
    return {
      countryMode: 'custom',
      activeQuickKeys:
        activeQuickKeys.length > 0 ? activeQuickKeys : [...DEFAULT_QUICK_KEYS],
      customCountries,
    };
  }

  return {
    countryMode: 'quick',
    activeQuickKeys:
      activeQuickKeys.length > 0 ? activeQuickKeys : [...DEFAULT_QUICK_KEYS],
    customCountries,
  };
}

export function loadCountryPrefs(): IXHashtagCountryPrefs | null {
  try {
    const raw = localStorage.getItem(getCountryPrefsStorageKey());
    if (!raw) {
      return null;
    }
    return normalizeCountryPrefs(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function saveCountryPrefs(prefs: IXHashtagCountryPrefs): void {
  try {
    localStorage.setItem(
      getCountryPrefsStorageKey(),
      JSON.stringify(prefs),
    );
  } catch {
    // ignore quota errors
  }
}
